
<script>
import New from './New3'
import Edit from '../Edit'
export default {
  mixins: [New, Edit]
}
</script>
